<template lang="pug">
app-page-layout
  a-spin.abs-fit.flex.align-center.justify-center(v-show="loading" style="z-index: 100;")
  div.handle-container.abs-fit
    //- a-card.mt1(:loading="modelLoading" :title="model.id ? '创建订单' : '处理订单'" hoverable)
    app-form(:model="model" :rules="rules" ref="form" oneline :labelWidth="110" :style="{'min-width': '1600px'}") 
      div.create-order.flex(style="gap: 16px;")
        //- a-card.mt1(v-if="model.id" title="商家下单信息" :hoverable="false" style="flex: 1; background: #f2f2f5;")
          VendorDetail(:target="model")
          div.p3
        a-card.mt1(title="商家下单信息" :hoverable="false" style="flex: 2;" :style="{background: model.id && post !== 'orderReceiver'? '#f2f2f5' : '#fff'}" )
          div.title 商家信息
          a-row(:gutter="16")
            a-col(:sm="12")    
              a-form-model-item(label="商家" prop="vendorId" )
                app-remote-select(
                  v-model="model.vendorId" api="/prj/vendors/list" :params="params" 
                  allow-clear placeholder="请选择商家"
                  @change="handleVendorChange"
                  :disabled="!!model.id"
                  showSearch
                )
              
            a-col(:sm="12")    
              a-form-model-item(label="座机" prop="vendorMobile" )
                a-input(v-model="model.vendorMobile" allow-clear :max-length="100"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入商家座机")
            a-col(:sm="24")    
              a-form-model-item(label="商家地址" prop="vendorAddress" )
                a-input(v-model="model.vendorAddress" allow-clear :max-length="100"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入商家地址")
            a-col(:sm="24")    
              a-form-model-item(label="联系人" prop="vendorContact" )
                a-input(v-model="model.vendorContact" allow-clear :max-length="100"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入联系人")

            
          div.title 客户信息
          a-row(:gutter="16")
            a-col(:sm="12")    
              a-form-model-item(label="收货人姓名" prop="customerName" )
                a-input(v-model="model.customerName" allow-clear :max-length="100"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入收货人姓名")
            
            a-col(:sm="12")    
              a-form-model-item(label="收货人手机" prop="customerMobile" )
                a-input(v-model="model.customerMobile" allow-clear :max-length="100"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入收货人手机")
            
            a-col(:sm="24")    
              a-form-model-item(label="收货人地址" prop="customerAddress" )
                a-input(v-model="model.customerAddress" allow-clear :max-length="100"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入收货人地址")
          a-row(:gutter="16")
            a-col(:sm="12")    
              a-form-model-item(label="出入库" prop="stockType" )
                app-remote-select(
                  v-model="model.stockType" 
                  placeholder="请选择出入库类型"
                  api="/sys/dict-datas/graph?typeCode=stockType" 
                  :params="params" 
                  :field="{ name: 'code', label: 'name' }"
                  allow-clear 
                  @change="() => {model.stockSubType = null;}"
                  :disabled="!!model.id"
                )
            a-col(:sm="12")    
              a-form-model-item(v-if="model.stockType === 'stockType_instock'" label="出入库子类" prop="stockSubType" )
                app-remote-select(
                  key="stockType_instock"
                  v-model="model.stockSubType" 
                  placeholder="请选择出入库子类"
                  api="/sys/dict-datas/graph?typeCode=instockType" 
                  :params="params" 
                  :dataFormatter="(data) => data.filter(item => item.code !== 'instockType_supply')"
                  :field="{ name: 'code', label: 'name' }"
                  allow-clear 
                  :disabled="!!model.id"
                )
              a-form-model-item(v-else-if="model.stockType === 'stockType_outstock'" label="出入库子类" prop="stockSubType" )
                app-remote-select(
                  key="stockType_outstock"
                  v-model="model.stockSubType" 
                  placeholder="请选择出入库子类"
                  api="/sys/dict-datas/graph?typeCode=outstockType" 
                  :params="params" 
                  :field="{ name: 'code', label: 'name' }"
                  allow-clear 
                  :disabled="!!model.id"
                )
              a-form-model-item(v-else label="出入库子类" prop="stockSubType" )
                app-remote-select(
                  key="stockType_other"
                  v-model="model.stockSubType" 
                  placeholder="请选择出入库子类"
                  api="/sys/dict-datas/graph?typeCode=serviceType" 
                  :params="params" 
                  :field="{ name: 'code', label: 'name' }"
                  allow-clear 
                  :disabled="!!model.id"
                )
            a-col(:sm="12")    
              //- （点位、计件）
              a-form-model-item(label="收费模式" prop="feeMode" )
                app-remote-select(
                  v-model="model.feeMode" 
                  placeholder="请选择收费模式"
                  api="/sys/dict-datas/graph?typeCode=feeMode" 
                  :params="params" 
                  :field="{ name: 'code', label: 'name' }"
                  allow-clear 
                  :disabled="!!model.id && post !== 'orderReceiver'" 
                )
            
            a-col(:sm="12")    
              a-form-model-item(label="订单金额" prop="amount" )
                a-input-number(v-model="model.amount" allow-clear :min="0"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入订单金额")
            a-col(:sm="12")    
              //- （仅财务可见）
              //- a-form-model-item(label="服务费用" prop="serviceFee" )                
                a-input-number(v-model="model.serviceFee" allow-clear :min="0"
                  :disabled="!model.id" placeholder="请输入服务费用")
        
            a-col(:sm="24")    
              a-form-model-item(label="提货地址" prop="pickupAddress" )
                a-input(v-model="model.pickupAddress" allow-clear :max-length="100"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入提货地址")  
            a-col(:sm="12")    
              a-form-model-item(label="预约送货时间" prop="appointmentTime" )
                a-date-picker(v-model="model.appointmentTime" :disabledDate="disabledDate" showTime format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear placeholder="请输入预约送货时间")
            a-col(v-if="!!model.id" :sm="12" )    
              a-form-model-item(label="预约送货状态" prop="appointmentStatus" )
                app-remote-select(
                  v-model="model.appointmentStatus" 
                  placeholder="请选择预约送货状态"
                  api="/sys/dict-datas/graph?typeCode=appointmentStatus" 
                  :params="params" 
                  :field="{ name: 'code', label: 'name' }"
                  allow-clear 
                  :disabled="post !== 'dispatch' && post !== 'orderReceiver'"
                )
            a-col(:sm="24")                    
              a-form-model-item(label="商家备注信息" prop="vendorComments" )
                a-textarea(v-model="model.vendorComments" allow-clear :max-length="500"
                  :disabled="!!model.id && post !== 'orderReceiver'" placeholder="请输入商家备注")
          div.title.flex 产品列表
          div 
            a-form-model-item(label="" prop="orderItems" )
              ProductDTOSVendors(v-model="model.orderItems" :productDTOS="model.orderItems" :target.sync="model" :post="post")
              

        a-card.mt1(title="仓库订单信息" hoverable style="flex: 3;")
          div.title 制单状态
          a-row(:gutter="16")            
            a-col(:sm="24")  
              a-form-model-item(label="制单状态" prop="isMarkOrder" )
                a-radio-group.p1(v-model="model.isMarkOrder")
                  a-radio(:value="true") 已制单
                  a-radio(:value="false") 未制单
                //- app-remote-select(
                //-   v-model="model.stockType" 
                //-   placeholder="请选择出入库类型"
                //-   api="/sys/dict-datas/graph?typeCode=stockType" 
                //-   :params="params" 
                //-   :field="{ name: 'code', label: 'name' }"
                //- )
          div.title 出入库类型
          a-row(:gutter="16")            
            //- a-col(v-if="model.dutyPostId === '1384149172863639553'" :sm="24")  
              a-form-model-item(label="预约送货时间" prop="appointmentTime" )
                a-date-picker(v-model="model.appointmentTime" :disabledDate="disabledDate" showTime format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss"
                  allow-clear placeholder="请输入预约送货时间")             
            a-col(:sm="24")  
              a-form-model-item(label="出入库时间" prop="stockTime" )
                a-date-picker(v-model="model.stockTime" allow-clear showTime placeholder="请选择出入库时间")              
            
            a-col(:sm="24")  
              a-form-model-item(label="接单员备注" prop="takerComments" )
                a-textarea(v-model="model.takerComments" allow-clear :max-length="100" placeholder="请输入接单员备注")
            
            
          div.title 车辆信息
          a-row(:gutter="16")              
            a-col(:sm="24") 
              a-form-model-item(label="" prop="carArranged" )
                CarRecordDTOS(v-model="model.carRecordDTOS" :target="model")
                //- a-input(v-model="model.carArranged" allow-clear :min="0" placeholder="请输入已配车辆")
                
            a-col(:sm="24")  
              a-form-model-item(label="调度员备注" prop="schedulerComments" )
                a-textarea(v-model="model.schedulerComments" allow-clear :max-length="100" placeholder="请输入调度员备注")

          div.title.flex 产品出入库列表
          a-row(:gutter="16") 
            a-col(:sm="24")  
              a-form-model-item(label="" prop="" )
                ProductDTOS(:productDTOS="model.orderItems" :target.sync="model")
            
            a-col(:sm="24")  
              a-form-model-item(label="库管备注" prop="keeperComments" )
                a-textarea(v-model="model.keeperComments" allow-clear :max-length="100" placeholder="请输入库管备注")
          
          div.title(
            v-if="['outstockType_pickup', 'outstockType_delivery', 'outstockType_express'].includes(model.stockSubType)"
          ) 物流信息
          a-row(:gutter="16" v-if="['outstockType_pickup', 'outstockType_delivery', 'outstockType_express'].includes(model.stockSubType)")
            
            a-col(:sm="24")  
              a-form-model-item(label="物流备注" prop="logisticsComments" )
                a-textarea(v-model="model.logisticsComments" allow-clear :max-length="100" placeholder="请输入库管备注")
                  
  Actions(:target="model" @reload="laodModel" @save="handleSubmit()" @do-action-success="$back()")
</template>

<script>
import ProductDTOSVendors from './Modal/ProductDTOSVendors';
import ProductDTOS from './Modal/ProductDTOS';
import CarRecordDTOS from './Modal/CarRecordDTOS';
import Actions from './Components/Actions/index';
import VendorDetail from './Components/VendorDetail/index';

import moment from 'moment';

import { GETTER_PROJECT, GETTER_USER } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  name: 'CreateAndEdit',
  components: {
    ProductDTOSVendors,
    CarRecordDTOS,
    ProductDTOS,
    Actions,
    VendorDetail,
  },
  data() {
    return {
      modelLoading: false,
      visible: false,
      loading: false,
      title: '创建订单',
      model: {
        vendorId: null,
        vendorMobile: null,
        vendorAddress: null,
        vendorContact: null,
        orderType: null,
        orderSubType: null,
        feeMode: null,
        amount: null,
        serviceFee: 0,
        pickupAddress: null,
        appointmentTime: null,
        appointmentStatus: null,
        customerName: null,
        customerMobile: null,
        // customerAddress: null,
        stockType: null,
        // stockType: 'out',
        stockSubType: null,
        // stockSubType: 'deout',
        stockTime: null,
        vendorComments: null,
        takerComments: null,
        keeperComments: null,
        schedulerComments: null,
        dutyPostId: null,
        dutyUserId: null,
        carArranged: null,
        status: null,
        orderItems: [],
        productDTOS: [],
        //
        isMarkOrder: false,
      },
      // rules: {
      //   vendorId: [{ required: true, message: '必填项' }],
      //   orderType: [{ required: true, message: '必填项' }],
      //   orderSubType: [{ required: true, message: '必填项' }],
      //   feeMode: [{ required: true, message: '必填项' }],
      //   amount: [{ required: true, message: '必填项' }],
      //   serviceFee: [{ required: true, message: '必填项' }],
      //   pickupAddress: [{ required: true, message: '必填项' }],
      //   customerName: [{ required: true, message: '必填项' }],
      //   customerMobile: [{ required: true, message: '必填项' }],
      //   customerAddress: [{ required: true, message: '必填项' }],
      //   stockType: [{ required: true, message: '必填项' }],
      //   stockSubType: [{ required: true, message: '必填项' }],
      //   // vendorComments: [{ required: true, message: '必填项' }],
      //   // takerComments: [{ required: true, message: '必填项' }],
      //   // keeperComments: [{ required: true, message: '必填项' }],
      //   // schedulerComments: [{ required: true, message: '必填项' }],
      //   // dutyPostId: [{ required: true, message: '必填项' }],
      //   // dutyUserId: [{ required: true, message: '必填项' }],
      //   // carArranged: [{ required: true, message: '必填项' }],
      //   // status: [{ required: true, message: '必填项' }],
      // },
      // 禁用日志
      disabledDays: [],

      /**
       * 岗位
       * dispatch 调度员
       * orderReceiver  接单员
       * warehouseManagement  库管
       * finance 财务
       */
      post: null,
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
      user: GETTER_USER,
    }),
    params() {
      return {
        projectId: this.project.id,
      };
    },
    id() {
      return this.$route.params.id;
    },
    rules() {
      const rules = {
        vendorId: [{ required: true, message: '必填项' }],
        // orderType: [{ required: true, message: '必填项' }],
        // orderSubType: [{ required: true, message: '必填项' }],
        feeMode: [{ required: true, message: '必填项' }],
        // amount: [{ required: true, message: '必填项' }],
        // serviceFee: [{ required: true, message: '必填项' }],
        pickupAddress: [{ required: true, message: '必填项' }],
        customerName: [{ required: true, message: '必填项' }],
        customerMobile: [{ required: true, message: '必填项' }],
        customerAddress: [{ required: true, message: '必填项' }],
        stockType: [{ required: true, message: '必填项' }],
        stockSubType: [{ required: true, message: '必填项' }],
        // orderItems: [{ required: true, message: '请选择产品' }],
        appointmentTime: [{ required: true, message: '请选择送货时间' }],
      };
      if (this.model.feeMode === 'feeMode_point') {
        rules.amount = [{ required: true, message: '必填项' }];
      }
      if (this.model.stockType !== 'stockType_other') {
        rules.orderItems = [{ required: true, message: '请选择产品' }];
      }
      return rules;
    },
  },
  created() {
    if (this.id) {
      this.laodModel();
      this.title = '编辑订单';
      this.intervalTicket = setInterval(() => {
        this.autosave();
      }, 30000);
    } else {
      this.modelLoading = false;
    }
    this.loadDisabledDates();
    if (this.project?.postDTOS?.length) {
      this.post = this.project.postDTOS[0].code;
    }
  },
  beforeDestroy() {
    if (this.intervalTicket) {
      clearInterval(this.intervalTicket);
    }
  },
  methods: {
    // 自动保存
    autosave() {
      this.$restful(`save:/prj/orders/staff`, {
        ...this.model,
        orderItems:
          this.model.orderItems?.map((item, index) => {
            return {
              ...item,
              sort: index,
            };
          }) || [],
        projectId: this.project.id,
      }).then(() => {
        this.$message.success('自动保存成功!');
      });
    },
    laodModel() {
      this.modelLoading = true;
      this.$restful(`GET:/prj/orders/${this.id}`)
        .then((res) => {
          this.model = {
            ...res,
            productDTOS: res?.orderItems?.map((item) => item.productDTO) || [],
          };
        })
        .then(() => {
          this.modelLoading = false;
        });
    },
    handleCancel() {
      this.$back();
    },
    // 转单
    handleTransfer() {},
    // 保存
    async handleSubmit() {
      const valid = await this.$refs.form.validate();
      if (valid) {
        // delete this.model.id;

        this.loading = true;
        this.$restful(`save:/prj/orders/staff`, {
          ...this.model,
          orderItems:
            this.model.orderItems?.map((item, index) => {
              return {
                ...item,
                sort: index,
              };
            }) || [],
          projectId: this.project.id,
        })
          .then(() => {
            this.$message.success(this.title + '成功!');
            this.$emit('modal-success');
            this.$back();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    // 商户改变
    handleVendorChange(v, option) {
      // console.log(v, option);
      const vendor = option?.data?.attrs?.data;
      if (vendor) {
        this.model.vendorMobile = vendor.phone;
        this.model.vendorAddress = vendor.address;
        this.model.feeMode = vendor.feeMode;
        this.model.vendorContact = vendor.contact;
      } else {
        this.model.vendorMobile = null;
        this.model.vendorAddress = null;
        this.model.feeMode = null;
        this.model.vendorContact = null;
      }
    },
    loadDisabledDates() {
      this.$restful('GET:/prj/order-time-configs', {
        projectId: this.project.id,
      }).then((res) => {
        // console.log('sddddd', res);
        this.disabledDays = res.configDTOS.map((item) => {
          return moment(item.beginTime, 'YYYY-MM-DD HH:mm:ss').format(
            'YYYY-MM-DD',
          );
        });
      });
    },
    // 禁用送货时间
    disabledDate(date) {
      let startDate = moment();
      const dateStr = date.format('YYYY-MM-DD');
      if (this.disabledDays?.includes(dateStr)) {
        return true;
      }
      return false;
      // if (startDate.hour() >= 12) {
      //   return !moment().add(1, 'days').isBefore(date, 'day');
      // } else {
      //   return !startDate.isBefore(date, 'day');
      // }
    },
  },
};
</script>

<style lang="less" scoped>
.handle-container {
  height: 100%;
  padding: 20px;
  overflow: auto;
  .detail-content {
    height: 100%;
    background-color: #fff;
    overflow: auto;
  }
}
.create-order {
  //
}
.title {
  padding: 2px 12px;
  border-left: 4px solid #1890ff;
  margin: 12px 0 12px -8px;
}
</style>
